import I18n from "^/config/i18n";

export default function orderValues() {
  return [
    {
      value: "date.rel",
      key: I18n.t("EventsOver sort by relevance"),
    },
    {
      value: "date.asc",
      key: I18n.t("EventsOver sort by latest first"),
    },
    {
      value: "date.desc",
      key: I18n.t("EventsOver sort by oldest first"),
    },
    {
      value: "title.asc",
      key: I18n.t("EventsOver sort by A-Z title"),
    },
    {
      value: "title.desc",
      key: I18n.t("EventsOver sort by Z-A title"),
    },
  ];
}
